/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Fra14Inputs */

const en__field_enum_csjensblank_fra14 = /** @type {(inputs: _Field_Enum_Csjensblank_Fra14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt University of Applied Sciences`)
};

const de__field_enum_csjensblank_fra14 = /** @type {(inputs: _Field_Enum_Csjensblank_Fra14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt University of Applied Sciences`)
};

/**
* | output |
* | --- |
* | "Frankfurt University of Applied Sciences" |
*
* @param {_Field_Enum_Csjensblank_Fra14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_fra14 = /** @type {((inputs?: _Field_Enum_Csjensblank_Fra14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Fra14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_fra14(inputs)
	return de__field_enum_csjensblank_fra14(inputs)
});
export { _field_enum_csjensblank_fra14 as "_field_enum_CSJENSBLANK_FRA" }